
export function tripTrackingShareUrl(userId, tripId = null) {
    if (tripId) {
        return `https://www.panamhighway.com/trips/${tripId}/${userId}`;
    }
    return `https://www.panamhighway.com/trips/all/${userId}`;
}
